import Error from '.Error';
import Proxy from '.Proxy';
import RegExp from '.RegExp';
import test from '.RegExp.prototype.test';

export { IMPORT as import };
export const {
	
	charset,
	import: IMPORT,
	namespace,
	media,
	page,
	'font-face': font_face,
	'counter-style': counter_style,
	'*keyframes': keyframes,
	supports,
	
	'*document': document,
	viewport,
	
	'url(': url_,
	'url-prefix(': url_prefix_,
	'domain(': domain_,
	
	has,
	of,
	
	'*animation-name': animation_name,
	
}                                                   = /*#__PURE__*/( () => {
	if ( /k/i.test('\u212A') || /s/i.test('\u017F') ) { throw Error(`ks`); }
	return new Proxy({}, {
		get: (is, keyword        ) => test.bind(RegExp('^' + keyword.replace('(', '\\(').replace('*', '(?:-[a-z][a-z\\d]*-)?') + '$', 'i'))
	});
} )();
